import api from "api";

export const fetchInfoSections = () => api.get("/page-sections");
export const fetchInfoSectionsByType = (type) => api.get(`/page-sections/type/${type}`);
